// import React, { useState, useEffect } from 'react';
// import SortByAlphabet from '../components/SortByAlphabet/SortByAlphabet';
// import Pagination from '../components/Pagination/Pagination';
// import { apiGET, apiPOST } from '../utilities/apiHelpers';
// import 'tailwindcss/tailwind.css';
// import KidneyMedicinesCard from '../components/kidneyMedicines/KidneyMedicinesCard';
// import { useParams } from 'react-router-dom';
// import scrollToTop from '../utilities/scrollToTop';
// import { useDispatch, useSelector } from 'react-redux';
// import { setCartCount } from '../redux/users/users';

// const BrandProducts = () => {
//     const [products, setProducts] = useState([]);
//     const [error, setError] = useState(null);
//     const [stepperProgressCartData, setStepperProgressCartData] = useState([]);
//     const userId = useSelector((state) => state.user?.userData?.id) || '';
//     const dispatch = useDispatch()

//     const [pagination, setPagination] = useState({
//         totalProducts: 0,
//         totalPages: 0,
//         currentPage: 1,
//         pageSize: 10,
//     });
//     const [selectedLetter, setSelectedLetter] = useState('');
//     const [loading, setLoading] = useState(false);
//     const { id } = useParams();

//     console.log(id)


//     const getUserStepperProgress = async () => {
//         if (userId) {
//             try {
//                 const stepperResponse = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`)
//                 setStepperProgressCartData(stepperResponse.data?.data);
//                 dispatch(setCartCount(stepperResponse.data?.data?.cartData.length));
//             } catch (error) {
//                 console.log("Error fetching cart details", error);
//             }
//         }
//     }

//     const getBrandData = async (sortIndex = '', page = 1) => {
//         try {
//             const payload = {
//                 sortIndex,
//                 limit: 10,
//                 page,
//             };

//             const response = await apiPOST(`/v1/product/getProductsByBrandId/${id}`, payload);
//             setProducts(response.data.data.product);
//             setPagination({
//                 totalProducts: response?.data?.data?.pagination?.totalProducts,
//                 totalPages: response?.data?.data?.pagination?.totalPages,
//                 currentPage: response?.data?.data?.pagination?.currentPage,
//                 pageSize: response?.data?.data?.pagination?.pageSize,
//             });
//             console.log("Response:", response);
//             console.log(products)
//         } catch (error) {
//             setError(error.message || 'Error fetching data');
//         }
//     };

//     useEffect(() => {
//         scrollToTop();
//         getBrandData();
//         getUserStepperProgress();
//     }, []);



//     useEffect(() => {
//         getBrandData(selectedLetter);
//     }, [selectedLetter]);

//     const handleLetterClick = (letter) => {
//         setSelectedLetter(letter);
//         getBrandData(letter, 1);
//     };

//     const handlePageChange = (page) => {
//         getBrandData(selectedLetter, page);
//     };

//     useEffect(() => {
//         getBrandData("");
//     }, []);


//     return (
//         <div className="container mx-auto p-4">
//             <SortByAlphabet onLetterClick={handleLetterClick} />
//             <h2 className={`${pagination?.totalProducts === 0 ? 'hidden' : ''}`}>Showing {pagination?.pageSize * (pagination?.currentPage - 1) + 1}-{Math.min(pagination?.pageSize * pagination?.currentPage, pagination?.totalProducts)} of {pagination.totalProducts} results</h2>


//             {/* {JSON.stringify(pagination)} */}
//             {loading ?
//                 <div className="flex justify-center items-center">
//                     <div className="loader">Loading...</div>
//                 </div>
//                 :
//                 <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-1'>
//                     {products?.length ? (
//                         products.map((item) => (
//                             <KidneyMedicinesCard key={item.id} item={item} stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} />
//                         ))
//                     ) : (
//                         <div className='col-span-full flex justify-center items-center'>
//                             <div className='border  border-[#095D7E] py-5 px-20 rounded-lg shadow-md text-center'>
//                                 Not Found
//                             </div>
//                         </div>
//                     )}
//                 </div>

//             }
//             <Pagination
//                 currentPage={pagination?.currentPage}
//                 totalPages={pagination?.totalPages}
//                 onPageChange={handlePageChange}
//             />
//         </div>
//     );
// };

// export default BrandProducts;

import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiGET, apiPOST } from '../utilities/apiHelpers';
import scrollToTop from '../utilities/scrollToTop';
import SortByAlphabet from '../components/SortByAlphabet/SortByAlphabet';
import Pagination from '../components/Pagination/Pagination';
import KidneyMedicinesBrand from '../components/kidneyMedicines/KindelyMedicineBrand';
import { setCartCount } from '../redux/users/users';
import 'tailwindcss/tailwind.css';

const BrandProducts = () => {
  const [products, setProducts] = useState([]);
  const [stepperProgressCartData, setStepperProgressCartData] = useState([]);
  const [pagination, setPagination] = useState({
    totalProducts: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  });
  const [selectedLetter, setSelectedLetter] = useState('');
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const userId = useSelector((state) => state.user?.userData?.id) || '';
  const dispatch = useDispatch();

  const getUserStepperProgress = useCallback(async () => {
    if (!userId) return;
    try {
      const stepperResponse = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`);
      setStepperProgressCartData(stepperResponse.data?.data || []);
      dispatch(setCartCount(stepperResponse.data?.data?.cartData?.length || 0));
    } catch (err) {
      console.error("Error fetching cart details", err);
    }
  }, [userId, dispatch]);

  const getBrandData = useCallback(async (sortIndex = '', page = 1) => {
    setLoading(true);
    try {
      const payload = {
        sortIndex,
        limit: pagination.pageSize,
        page,
      };
      const response = await apiPOST(`/v1/product/getProductsByBrandId/${id}`, payload);

      setProducts(response.data.data.product || []);
      const paginationData = response.data?.data?.pagination || {};
      setPagination({
        totalProducts: paginationData.totalProducts || 0,
        totalPages: paginationData.totalPages || 0,
        currentPage: paginationData.currentPage || 1,
        pageSize: paginationData.pageSize || 10,
      });
    } catch (err) {
      console.error("Error fetching brand data", err);
    } finally {
      setLoading(false);
    }
  }, [id, pagination.pageSize]);

  useEffect(() => {
    scrollToTop();
    getBrandData();
    getUserStepperProgress();
  }, [getBrandData, getUserStepperProgress]);

  useEffect(() => {
    getBrandData(selectedLetter, 1);
  }, [selectedLetter, getBrandData]);

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
  };

  const handlePageChange = (page) => {
    getBrandData(selectedLetter, page);
  };

  return (
    <div className="container mx-auto p-4">
      <SortByAlphabet onLetterClick={handleLetterClick} />

      {pagination.totalProducts > 0 && (
        <h2>
          Showing {pagination.pageSize * (pagination.currentPage - 1) + 1}-
          {Math.min(pagination.pageSize * pagination.currentPage, pagination.totalProducts)} of{' '}
          {pagination.totalProducts} results
        </h2>
      )}

      {loading ? (
        <div className="flex justify-center items-center">
          <div className="loader">Loading...</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-1">
          {products.length ? (
            products.map((item) => (
              <KidneyMedicinesBrand
                key={item.id}
                item={item}
                stepperProgressCartData={stepperProgressCartData}
                setStepperProgressCartData={setStepperProgressCartData}
              />
            ))
          ) : (
            <div className="col-span-full flex justify-center items-center">
              <div className="border border-[#095D7E] py-5 px-20 rounded-lg shadow-md text-center">
                Not Found
              </div>
            </div>
          )}
        </div>
      )}

      <Pagination
        currentPage={pagination.currentPage}
        totalPages={pagination.totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default BrandProducts;

